import { InfoIcon, CheckCircleIcon } from '@allurion/ui';
import { toast, ToastOptions } from 'react-toastify';

import { GENERIC_TOAST_ID } from 'src/utils/constants';

import styles from './toasts.module.scss';

function ToastLayout({ icon, msg }: any) {
  return (
    <div className={styles.toastWrapper} data-sentry-unmask>
      <div className={styles.iconWrapper}>{icon}</div>
      <span className={styles.toastMessage}>{msg}</span>
    </div>
  );
}

const renderSuccess = (msg: string | any) => <ToastLayout msg={msg} icon={<CheckCircleIcon />} />;
const renderError = (msg: string | any) => <ToastLayout msg={msg} icon={<InfoIcon />} />;
const renderInfo = (msg: string | any) => <ToastLayout msg={msg} icon={<InfoIcon />} />;
const renderWarning = (msg: string | any) => <ToastLayout msg={msg} icon={<InfoIcon />} />;

export const toastSuccess = (msg: string | any, opts: Partial<ToastOptions> = {}) => {
  toast(renderSuccess(msg), {
    type: toast.TYPE.SUCCESS,
    ...opts,
    className: 'toast-container',
    containerId: GENERIC_TOAST_ID,
    icon: false,
  } as ToastOptions);
};

export const toastInfo = (msg: string | any, opts: Partial<ToastOptions> = {}) =>
  toast(renderInfo(msg), {
    type: toast.TYPE.INFO,
    ...opts,
    className: 'toast-container',
    containerId: GENERIC_TOAST_ID,
    icon: false,
  } as ToastOptions);

export const toastError = (msg: string | any, opts: Partial<ToastOptions> = {}) => {
  toast(renderError(msg), {
    type: toast.TYPE.ERROR,
    ...opts,
    containerId: GENERIC_TOAST_ID,
    icon: false,
  } as ToastOptions);
};

export const toastWarning = (msg: string | any, opts: Partial<ToastOptions> = {}) =>
  toast(renderWarning(msg), {
    type: toast.TYPE.WARNING,
    ...opts,
    containerId: GENERIC_TOAST_ID,
    icon: false,
  } as ToastOptions);
